const firstLvlMenuData = [{
  name: "数据输入",
  code: "dataInput",
  show: true
}, {
  name: "数据分析",
  code: "dataAnalysis",
  show: true
},{
  name: "数据输出",
  code: "dataOutput",
  show: true
},{
  name: "系统管理",
  code: "system",
  show: true
},{
  name: "疫情设置",
  code: "epidemic",
  show: true
}]

const secLvlMenuData = {
  name: "ZVOS Menu",
  children: [
    {
      name: "数据采集",
      icon: "zv-icon-home",
      isShow: true,
      pCode: "dataInput",
      code: "dataCollect",
      children: [
        {
          name: "信息管理",
          url: "/data-input/collectDataList",
          isShow: true,
          code: "collectDataList"
        },
        {
          name: "采集源管理",
          url: "/data-input/collectSourceList",
          isShow: true,
          code: "collectSourceList"
        }
      ]
    },
    {
      name: "信息库",
      icon: "zv-icon-device",
      isShow: true,
      pCode: "dataInput",
      code: "RecordInput",
      children: [
        {
          name: "事件库",
          url: "/data-input/eventList",
          isShow: true,
          code: "eventList"
        },
        {
          name: "国别基础信息库",
          url: "/data-input/countryBase",
          isShow: true,
          code: "countryBase"
        },
        {
          name: "应对库",
          url: "/data-input/responseLibrary",
          isShow: true,
          code: "responseLibrary"
        },
        {
          name: "安全服务",
          url: "/data-input/services",
          isShow: true,
          code: "services"
        },
        {
          name: "恐怖组织信息库",
          url: "/data-input/organizations",
          isShow: true,
          code: "organizations"
        }
      ]
    },
    {
      name: "文章管理",
      icon: "zv-icon-config",
      isShow: true,
      pCode: "dataInput",
      code: "dataCollect",
      children: [
        {
          name: "文章列表",
          url: "/data-input/articleList",
          isShow: true,
          code: "articleList"
        },
        // {
        //   name: "文章详情",
        //   url: "/data-input/addArticle",
        //   isShow: false,
        //   code: "addArticle"
        // },
        {
          name: "文章分类管理",
          url: "/data-input/category",
          isShow: true,
          code: "category"
        },
        {
          name: "文章字段管理",
          url: "/data-input/articleField",
          isShow: true,
          code: "articleField"
        },
        // {
        //   name: "查看评论",
        //   url: "/data-input/viewComments",
        //   isShow: true,
        //   code: "viewComments"
        // },
        {
          name: "评论管理",
          url: "/data-input/commentManagement",
          isShow: true,
          code: "commentManagement"
        },
        {
          name: "事件类型管理",
          url: "/data-input/eventType",
          isShow: true,
          code: "eventType"
        },
        {
          name: "事件统计",
          url: "/data-input/statistics",
          isShow: true,
          code: "statistics"
        }
      ]
    },
    {
      name: "专题管理",
      icon: "zv-icon-terminal",
      isShow: true,
      pCode: "dataInput",
      code: "dataCollect",
      children: [
        {
          name: "专题列表",
          url: "/data-input/listofTopics",
          isShow: true,
          code: "listofTopics"
        }
      ]
    },
    {
      name: "数据库",
      icon: "zv-icon-analysis",
      isShow: true,
      pCode: "dataInput",
      code: "dataCollect",
      children: [
        {
          name: "专家库",
          url: "/data-input/expertDatabase",
          isShow: true,
          code: "expertDatabase"
        },
        {
          name: "媒体库",
          url: "/data-input/mediaLibrary",
          isShow: true,
          code: "mediaLibrary"
        }
      ]
    },

    {
      name: "分析模型",
      icon: "zv-icon-analysis",
      isShow: true,
      pCode: "dataAnalysis",
      code: "analysisMode",
      children: [
        {
          name: "模型管理",
          url: "/data-analysis/modelList",
          isShow: true,
          code: "modelList"
        }
      ]
    },
    {
      name: "配置管理",
      icon: "zv-icon-config",
      isShow: true,
      pCode: "dataAnalysis",
      code: "configManage",
      children: [
        {
          name: "地区库管理",
          url: "/data-analysis/areaList",
          isShow: true,
          code: "areaList"
        },
        {
          name: "风险分类管理",
          url: "/data-analysis/riskTypeList",
          isShow: true,
          code: "riskTypeList"
        },
        {
          name: "国家配置管理",
          url: "/data-analysis/areaConfigList",
          isShow: true,
          code: "areaConfigList"
        }
      ]
    },


    {
      name: "管理员管理",
      icon: "zv-icon-user",
      isShow: true,
      pCode: "system",
      code: "adminManage",
      children: [
        {
          name: "成员管理",
          url: "/system/memberList",
          isShow: true,
          code: "memberList"
        },
        {
          name: "角色管理",
          url: "/system/roleList",
          isShow: true,
          code: "roleList"
        }
      ]
    },

    {
      name: "产品权限管理",
      icon: "zv-icon-device",
      isShow: true,
      pCode: "system",
      code: "adminManage",
      children: [
        {
          name: "预警系统",
          url: "/system/earlyWarning",
          isShow: true,
          code: "earlyWarning"
        },
        {
          name: "预警系统政府版",
          url: "/system/earlyWarning-G",
          isShow: true,
          code: "earlyWarning-G"
        },
        {
          name: "默认权限设置",
          url: "/system/permissionSettings",
          isShow: false,
          code: "permissionSettings"
        },
        {
          name: "默认权限设置政府版",
          url: "/system/permissionSettings-G",
          isShow: false,
          code: "permissionSettings-G"
        }
      ]
    },
    {
      name: "用户管理",
      icon: "zv-icon-terminal",
      isShow: true,
      pCode: "system",
      code: "adminManage",
      children: [
        {
          name: "用户管理",
          isShow: true,
          code: "businessManagement",
          url: "/system/businessManagement"
        },
        // {
        //   name: "企业管理政府版",
        //   isShow: true,
        //   code: "businessManagement-G",
        //   url: "/system/businessManagement-G"
        // },
        {
          name: "定制权限",
          url: "/system/customPermissions",
          isShow: false,
          code: "customPermissions"
        },
        {
          name: "定制权限政府版",
          url: "/system/customPermissions-G",
          isShow: false,
          code: "customPermissions-G"
        }
      ]
    },
    // {
    //   name: "后台用户管理",
    //   icon: "zv-icon-terminal",
    //   isShow: true,
    //   pCode: "system",
    //   code: "adminManage",
    //   children: [
    //     {
    //       name: "用户管理",
    //       isShow: true,
    //       code: "userManagement",
    //       url: "/system/userManagement"
    //     },
    //     {
    //       name: "角色管理",
    //       url: "/system/roleManagement",
    //       isShow: true,
    //       code: "roleManagement"
    //     },
    //     {
    //       name: "权限分配",
    //       url: "/system/authorityAssignment",
    //       isShow: true,
    //       code: "authorityAssignment"
    //     },
    //     {
    //       name: "用户分配",
    //       url: "/system/userAssignment",
    //       isShow: true,
    //       code: "userAssignment"
    //     }
    //   ]
    // },

    {
      name: "APP管理",
      icon: "zv-icon-design",
      isShow: true,
      pCode: "system",
      code: "appManage",
      url: "/system/appList"
    },
    // {
    //   name: "用户管理",
    //   icon: "zv-icon-config",
    //   isShow: true,
    //   pCode: "system",
    //   code: "userManagement",
    //   url: "/system/userManagement"
    // },
    {
      name: "输出配置",
      icon: "zv-icon-terminal",
      isShow: true,
      pCode:"dataOutput",
      code: "dataExport",
      children: [
        {
          name: "大屏配置",
          url: "/data-output/ScreenConfiguration",
          isShow: true,
          code: "ScreenConfiguration"
        },
        {
          name: "信息推送",
          url: "/data-output/informationPush",
          isShow: true,
          code: "informationPush"
        },
        {
          name: "安全咨询",
          url: "/data-output/consultation",
          isShow: true,
          code: "consultation"
        },
        {
          name: "字段配置",
          url: "/data-output/fieldConfiguration",
          isShow: false,
          code: "fieldConfiguration"
        },
        // {
        //   name: "公告管理",
        //   url: "/data-output/Announcements",
        //   isShow: true,
        //   code: "Announcements"
        // },
        // {
        //   name: "短信群发",
        //   url: "/data-output/MassSMS",
        //   isShow: true,
        //   code: "MassSMS"
        // }
      ]
    },
    {
      name: "安全管理体系",
      icon: "zv-icon-design",
      isShow: true,
      pCode:"dataOutput",
      code: "dataExport",
      children: [
        {
          name: "文件管理",
          url: "/data-output/fileManagement",
          isShow: true,
          code: "fileManagement"
        },
        {
          name: "问答管理",
          url: "/data-output/questionManagement",
          isShow: true,
          code: "questionManagement"
        },
      ]
    },
    {
      name: "地区配置",
      icon: "zv-icon-terminal",
      url: "/epidemic",
      isShow: true,
      pCode: "epidemic",
      // code: "dataOutput",
      children: [{
        name: "地区列表",
        url: "/epidemic/epideAreaList",
        isShow: true,
        code: "epideAreaList"
      },
        {
          name: "基础信息",
          url: "/epidemic/baseInformation",
          isShow: false,
          code: "baseInformation"
        },
        {
          name: "疫情数据-国家",
          url: "/epidemic/epidemicDatas",
          isShow: false,
          code: "epidemicDatas"
        }
      ]
    }
  ]
};

export {
  firstLvlMenuData,
  secLvlMenuData
}
